import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, RSelect } from '../../../components/Component';
import { Link } from 'react-router-dom';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_tenant_sales_reps, loading_retrieve_tenant_sales_reps, reset_retrieve_tenant_sales_reps, success_retrieve_tenant_sales_reps } from '../../../reducers/auth_tenant/retrieve_tenant_sales_reps_Slice';
import { ADD_TENANT_SALES_REPRESENTATIVES_ERROR_MSG, ADD_TENANT_SALES_REPRESENTATIVES_SUCCESS_MSG, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, RETRIEVE_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_SALES_REPRESENTATIVES_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { ADD_TENENT_SALES_REP_API, RETRIEVE_BRANDS_LIST_API, RETRIEVE_TENANT_SALES_REPS_API } from '../../../api/api_data';
import { messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../utils/app_consts";
import { Alert, Badge, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import TextInput from '../../components/inputs/TextInput';
import { fail_retrieve_brands_list, loading_retrieve_brands_list, reset_retrieve_brands_list, success_retrieve_brands_list } from '../../../reducers/auth_tenant/retrieve_brands_list_Slice';
import { fail_add_tenant_sales_rep, loading_add_tenant_sales_rep, reset_add_tenant_sales_rep, success_add_tenant_sales_rep } from '../../../reducers/auth_tenant/add_tenant_sales_rep_Slice';
import moment from 'moment';
import PhoneInput from 'react-phone-input-2';

const initialSalesRepState = { name: "", mobile_numer: "", email_address: "", type: "", tpin: "", allowed_products: [], mobile_number: "" };

const SalesRepManagement = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sales_rep_data, setSalesRepData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [sm, updateSm] = useState(false);
  const [add_sales_rep_modal, setSalesRepModal] = useState(false);
  const [retrieve_sales_rep_data, setRetrieveSalesRepData] = useState([]);
  const [retrieve_sales_rep_loading, setRetrieveSalesRepLoading] = useState([]);
  const [add_sales_rep_loading, setAddSalesRepLoading] = useState(false);
  const [add_sales_rep_error, setAddSalesRepError] = useState("");
  const [brands, setBrands] = useState([]);
  const [add_sales_rep_form_data, setAddSalesRepFormData] = useState(initialSalesRepState);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    retrieve_sales_reps();
  }, []);


  const retrieve_sales_reps = () => {
    setError("");
    setLoading(true);
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_sales_reps, success_retrieve_tenant_sales_reps, fail_retrieve_tenant_sales_reps, RETRIEVE_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_SALES_REPRESENTATIVES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SALES_REPS_API}`));
  };

  // Listener
  const retrieve_tenant_sales_reps_listener = useSelector((state) => state.retrieve_tenant_sales_reps.retrieve_tenant_sales_reps);

  useEffect(() => {
    if (retrieve_tenant_sales_reps_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_sales_reps_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_sales_reps_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_sales_reps_listener.message);
          messageToast(retrieve_tenant_sales_reps_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_sales_reps_listener.status === app_consts.SUCCESS)
        {
          setSalesRepData(retrieve_tenant_sales_reps_listener.data);
          setCurrentPageData(retrieve_tenant_sales_reps_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_sales_reps());
      }
    }
  }, [retrieve_tenant_sales_reps_listener]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  // UseEffect for Search 
  useEffect(() => {
    filtered_sales_reps(searchTerm);
  }, [searchTerm]);

  const filtered_sales_reps = (searchItem) => {
    if (searchItem)
    {
      let displayedSalesReps;

      displayedSalesReps = sales_rep_data?.filter((item) => {
        const combinedParams = [
          item?.mobile_number,
          item.name,
          item.email_address,
          item.type,
          item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--",
          item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(startIndex, endIndex);

      setCurrentPageData(displayedSalesReps);
    } else
    {
      setCurrentPageData(sales_rep_data);
    }
  };

  const open_add_sales_rep_modal = () => {
    setAddSalesRepError("");
    setSalesRepModal(true);
    setAddSalesRepFormData(initialSalesRepState);
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_brands_list, success_retrieve_brands_list, fail_retrieve_brands_list, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_BRANDS_LIST_API}`));
  };

  const clost_add_sales_rep_modal = () => {
    setAddSalesRepError("");
    setSalesRepModal(false);
    setAddSalesRepFormData(initialSalesRepState);
  };
  // Listener
  const retrieve_categories_listener = useSelector((state) => state.retrieve_brands_list.retrieve_brands_list);

  useEffect(() => {
    if (retrieve_categories_listener.status !== app_consts.IDLE)
    {
      if (retrieve_categories_listener.status === app_consts.LOADING)
      {
        setRetrieveSalesRepLoading(true);
      } else
      {
        setRetrieveSalesRepLoading(false);
        if (retrieve_categories_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_categories_listener.message, app_consts.FAIL);
        } else if (retrieve_categories_listener.status === app_consts.SUCCESS)
        {
          // Set Brands
          const categories = retrieve_categories_listener.data?.map((cat) => { return { label: cat, value: cat }; });
          setBrands(categories);
        }
        dispatch(reset_retrieve_brands_list());
      }
    }
  }, [retrieve_categories_listener]);

  // Handle Change Function
  const handleChange = (e) => {
    setAddSalesRepFormData({ ...add_sales_rep_form_data, [e.target.name]: e.target.value });
  };

  const handleSubmitAddSalesRep = () => {
    setAddSalesRepError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_add_tenant_sales_rep, success_add_tenant_sales_rep, fail_add_tenant_sales_rep, ADD_TENANT_SALES_REPRESENTATIVES_ERROR_MSG, ADD_TENANT_SALES_REPRESENTATIVES_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADD_TENENT_SALES_REP_API}`, add_sales_rep_form_data));
  };
  // Listener
  const add_tenant_sales_rep_listener = useSelector((state) => state.add_tenant_sales_rep.add_tenant_sales_rep);

  useEffect(() => {
    if (add_tenant_sales_rep_listener.status !== app_consts.IDLE)
    {
      if (add_tenant_sales_rep_listener.status === app_consts.LOADING)
      {
        setAddSalesRepLoading(true);
        setAddSalesRepError("");
      } else
      {
        setAddSalesRepLoading(false);
        if (add_tenant_sales_rep_listener.status === app_consts.FAIL)
        {
          messageToast(add_tenant_sales_rep_listener.message, app_consts.FAIL);
          setAddSalesRepError(add_tenant_sales_rep_listener.message);
        } else if (add_tenant_sales_rep_listener.status === app_consts.SUCCESS)
        {
          messageToast(add_tenant_sales_rep_listener.message, app_consts.SUCCESS);
          retrieve_sales_reps();
          clost_add_sales_rep_modal();
        }
        dispatch(reset_add_tenant_sales_rep());
      }
    }
  }, [add_tenant_sales_rep_listener]);


  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Sales Representatives` : "Sales Representatives"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Sales Representatives</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Sales Reps ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_sales_reps();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Sales Reps"
                              />
                            </div>
                          </li>
                          {
                            user_info?.roles?.includes(app_consts.ADD_SALES_REP) && (
                              <>
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      open_add_sales_rep_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      open_add_sales_rep_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Add Sales Rep</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Sales Reps..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      sales_rep_data && sales_rep_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Username</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Type</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Total Orders</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Date Created</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Last Login</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/sales_rep/${item?.id}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.name ? item?.name : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                            <span>{item?.email_address || "--"}  | {item?.mobile_number || "--"} </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.type || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.total_orders || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-date">{item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "danger"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.status?.toUpperCase() || "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link to={`/${tenant_info.url_prefix}/sales_rep/${item?.id}`}>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Button className="btn-pd-auto d-sm-none">
                                        <Icon name="chevron-right"></Icon>
                                      </Button>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Sales Reps Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>

      {/* Add Sales Rep Modal */}
      < Modal isOpen={add_sales_rep_modal} className="modal-dialog-centered" size={"lg"} >
        <ModalHeader toggle={add_sales_rep_loading ? "" : clost_add_sales_rep_modal}>Add Sales Representative</ModalHeader>
        <ModalBody>
          <Row className="g-4">
            <TextInput
              label="Name"
              type="text"
              id_val="name"
              value={add_sales_rep_form_data?.name}
              colSize="6"
              name="name"
              required
              handleChange={handleChange}
            />
            <Col lg="6">
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="mobile_number">
                    Mobile Number<span className='text-danger pr-2'>{`* `}</span>
                  </label>
                </div>
                <div className="form-control-wrap">
                  <PhoneInput
                    country={"zm"}
                    value={add_sales_rep_form_data.mobile_number}
                    onChange={(phone) => setAddSalesRepFormData({ ...add_sales_rep_form_data, mobile_number: phone })}
                    copyNumbersOnly={false}
                    inputStyle={{ width: '100%' }}
                  />
                </div>
              </div>
            </Col>
            <TextInput
              label="Email Address"
              type="text"
              id_val="email_address"
              value={add_sales_rep_form_data?.email_address}
              colSize="6"
              name="email_address"
              required
              handleChange={handleChange}
            />
            <TextInput
              label="Type"
              type="text"
              id_val="type"
              value={add_sales_rep_form_data?.type}
              colSize="6"
              name="type"
              required
              handleChange={handleChange}
            />
            <TextInput
              label="TPIN (optional)"
              type="number"
              maxlength="10"
              id_val="tpin"
              value={add_sales_rep_form_data?.tpin}
              colSize="6"
              name="tpin"
              handleChange={handleChange}
            />


            <Col size={6}>
              <div className="form-group">
                {/* Label row with inline checkbox */}
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label text-md mb-0" htmlFor="packet_size">
                    Allowed Products
                    <span className="text-danger ml-1">*</span>
                  </label>

                  <label className="mb-0 d-flex align-items-center" style={{ fontSize: "0.9rem", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      style={{ marginRight: 4 }}
                      checked={add_sales_rep_form_data?.allowed_products?.length === brands.length}
                      onChange={(e) => {
                        const allValues = e.target.checked ? brands.map((b) => b.value) : [];
                        setAddSalesRepFormData({
                          ...add_sales_rep_form_data,
                          allowed_products: allValues,
                        });
                      }}
                      className="mr-1"
                    />
                    <span className='ml-2'>Select All </span>

                  </label>
                </div>

                {/* Multi-select */}
                <div className="w-100">
                  <RSelect
                    options={brands}
                    isMulti
                    id="packet_size"
                    placeholder="Search"
                    className="w-100"
                    value={brands.filter((b) =>
                      add_sales_rep_form_data.allowed_products?.includes(b.value)
                    )}
                    onChange={(selected) => {
                      const values = selected?.map((val) => val.value) || [];
                      setAddSalesRepFormData({
                        ...add_sales_rep_form_data,
                        allowed_products: values,
                      });
                    }}
                  />
                </div>
              </div>
            </Col>

            {add_sales_rep_error && (
              <div className="mb-3 w-100">
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {add_sales_rep_error}{" "}
                </Alert>
              </div>
            )}
            <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
              <Button onClick={handleSubmitAddSalesRep} disabled={add_sales_rep_loading || !(add_sales_rep_form_data?.name && add_sales_rep_form_data?.allowed_products?.length > 0 && add_sales_rep_form_data?.email_address && add_sales_rep_form_data?.mobile_number && add_sales_rep_form_data?.type)} color="primary">
                {add_sales_rep_loading ? <Spinner size="sm" color="light" /> : "Add Sales Rep"}
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};


const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "300px",
    gap: "8px",
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "8px",
  },
  bubbleContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },
  bubble: {
    display: "flex",
    alignItems: "center",
    color: "white",
    padding: "5px 10px",
    borderRadius: "15px",
    fontSize: "14px",
  },
  close: {
    marginLeft: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
};

export default SalesRepManagement;